'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _botFlow = require('./bot-flow.html');

var _botFlow2 = _interopRequireDefault(_botFlow);

var _botFlow3 = require('./bot-flow.controller');

var _botFlow4 = _interopRequireDefault(_botFlow3);

require('./bot-flow.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var botFlowComponent = {
  restrict: 'E',
  bindings: {},
  template: _botFlow2.default,
  controller: _botFlow4.default,
  controllerAs: 'vm'
};

exports.default = botFlowComponent;


/** WEBPACK FOOTER **
 ** ./client/app/containers/bot-flow/bot-flow.component.js
 **/